/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SystemRouteRouteImport } from './routes/system/route'
import { Route as ClientRouteRouteImport } from './routes/_client/route'
import { Route as SystemAuthRouteRouteImport } from './routes/system/_auth/route'
import { Route as ClientAuthRouteRouteImport } from './routes/_client/_auth/route'
import { Route as SystemAuthIndexRouteImport } from './routes/system/_auth/index'
import { Route as ClientAuthIndexRouteImport } from './routes/_client/_auth/index'
import { Route as SystemAuthSplatRouteImport } from './routes/system/_auth/$'
import { Route as ClientAuthSplatRouteImport } from './routes/_client/_auth/$'
import { Route as SystemAuthSurveysRouteRouteImport } from './routes/system/_auth/surveys/route'
import { Route as ClientAuthSurveysRouteRouteImport } from './routes/_client/_auth/surveys/route'
import { Route as SystemAuthUsersIndexRouteImport } from './routes/system/_auth/users/index'
import { Route as SystemAuthSurveysIndexRouteImport } from './routes/system/_auth/surveys/index'
import { Route as SystemAuthReportingIndexRouteImport } from './routes/system/_auth/reporting/index'
import { Route as SystemAuthProfileIndexRouteImport } from './routes/system/_auth/profile/index'
import { Route as SystemAuthOrganizationsIndexRouteImport } from './routes/system/_auth/organizations/index'
import { Route as ClientAuthUsersIndexRouteImport } from './routes/_client/_auth/users/index'
import { Route as ClientAuthSurveysIndexRouteImport } from './routes/_client/_auth/surveys/index'
import { Route as ClientAuthReportsIndexRouteImport } from './routes/_client/_auth/reports/index'
import { Route as ClientAuthProfileIndexRouteImport } from './routes/_client/_auth/profile/index'
import { Route as SystemAuthOrganizationsOrganizationIdRouteRouteImport } from './routes/system/_auth/organizations/$organizationId/route'
import { Route as SystemAuthSurveysSummariesIndexRouteImport } from './routes/system/_auth/surveys/summaries/index'
import { Route as SystemAuthSurveysQuestionsIndexRouteImport } from './routes/system/_auth/surveys/questions/index'
import { Route as SystemAuthSurveysCommentsIndexRouteImport } from './routes/system/_auth/surveys/comments/index'
import { Route as SystemAuthSurveysCategoriesIndexRouteImport } from './routes/system/_auth/surveys/categories/index'
import { Route as SystemAuthOrganizationsOrganizationIdIndexRouteImport } from './routes/system/_auth/organizations/$organizationId/index'
import { Route as ClientAuthSurveysSummariesIndexRouteImport } from './routes/_client/_auth/surveys/summaries/index'
import { Route as ClientAuthSurveysQuestionsIndexRouteImport } from './routes/_client/_auth/surveys/questions/index'
import { Route as ClientAuthSurveysCommentsIndexRouteImport } from './routes/_client/_auth/surveys/comments/index'
import { Route as ClientAuthSurveysCategoriesIndexRouteImport } from './routes/_client/_auth/surveys/categories/index'
import { Route as SystemAuthReportingTasksNewIndexRouteImport } from './routes/system/_auth/reporting/tasks/new/index'
import { Route as SystemAuthReportingTasksTaskIdIndexRouteImport } from './routes/system/_auth/reporting/tasks/$taskId/index'
import { Route as SystemAuthOrganizationsOrganizationIdUsersIndexRouteImport } from './routes/system/_auth/organizations/$organizationId/users/index'
import { Route as SystemAuthOrganizationsOrganizationIdSurveysIndexRouteImport } from './routes/system/_auth/organizations/$organizationId/surveys/index'
import { Route as SystemAuthOrganizationsOrganizationIdSurveySettingsIndexRouteImport } from './routes/system/_auth/organizations/$organizationId/survey-settings/index'
import { Route as SystemAuthOrganizationsOrganizationIdReportsIndexRouteImport } from './routes/system/_auth/organizations/$organizationId/reports/index'
import { Route as SystemAuthOrganizationsOrganizationIdProfileIndexRouteImport } from './routes/system/_auth/organizations/$organizationId/profile/index'
import { Route as SystemAuthOrganizationsOrganizationIdOthersIndexRouteImport } from './routes/system/_auth/organizations/$organizationId/others/index'
import { Route as SystemAuthOrganizationsOrganizationIdMappingIndexRouteImport } from './routes/system/_auth/organizations/$organizationId/mapping/index'
import { Route as ClientAuthUsersUserIdSurveyPermissionsIndexRouteImport } from './routes/_client/_auth/users/$userId/survey-permissions/index'
import { Route as SystemAuthOrganizationsOrganizationIdUsersUserIdSurveyPermissionsIndexRouteImport } from './routes/system/_auth/organizations/$organizationId/users/$userId/survey-permissions/index'

const SystemRouteRoute = SystemRouteRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientRouteRoute = ClientRouteRouteImport.update({
  id: '/_client',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemAuthRouteRoute = SystemAuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => SystemRouteRoute,
} as any)
const ClientAuthRouteRoute = ClientAuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => ClientRouteRoute,
} as any)
const SystemAuthIndexRoute = SystemAuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SystemAuthRouteRoute,
} as any)
const ClientAuthIndexRoute = ClientAuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ClientAuthRouteRoute,
} as any)
const SystemAuthSplatRoute = SystemAuthSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => SystemAuthRouteRoute,
} as any)
const ClientAuthSplatRoute = ClientAuthSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => ClientAuthRouteRoute,
} as any)
const SystemAuthSurveysRouteRoute = SystemAuthSurveysRouteRouteImport.update({
  id: '/surveys',
  path: '/surveys',
  getParentRoute: () => SystemAuthRouteRoute,
} as any)
const ClientAuthSurveysRouteRoute = ClientAuthSurveysRouteRouteImport.update({
  id: '/surveys',
  path: '/surveys',
  getParentRoute: () => ClientAuthRouteRoute,
} as any)
const SystemAuthUsersIndexRoute = SystemAuthUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => SystemAuthRouteRoute,
} as any)
const SystemAuthSurveysIndexRoute = SystemAuthSurveysIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SystemAuthSurveysRouteRoute,
} as any)
const SystemAuthReportingIndexRoute =
  SystemAuthReportingIndexRouteImport.update({
    id: '/reporting/',
    path: '/reporting/',
    getParentRoute: () => SystemAuthRouteRoute,
  } as any)
const SystemAuthProfileIndexRoute = SystemAuthProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => SystemAuthRouteRoute,
} as any)
const SystemAuthOrganizationsIndexRoute =
  SystemAuthOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => SystemAuthRouteRoute,
  } as any)
const ClientAuthUsersIndexRoute = ClientAuthUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => ClientAuthRouteRoute,
} as any)
const ClientAuthSurveysIndexRoute = ClientAuthSurveysIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ClientAuthSurveysRouteRoute,
} as any)
const ClientAuthReportsIndexRoute = ClientAuthReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => ClientAuthRouteRoute,
} as any)
const ClientAuthProfileIndexRoute = ClientAuthProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => ClientAuthRouteRoute,
} as any)
const SystemAuthOrganizationsOrganizationIdRouteRoute =
  SystemAuthOrganizationsOrganizationIdRouteRouteImport.update({
    id: '/organizations/$organizationId',
    path: '/organizations/$organizationId',
    getParentRoute: () => SystemAuthRouteRoute,
  } as any)
const SystemAuthSurveysSummariesIndexRoute =
  SystemAuthSurveysSummariesIndexRouteImport.update({
    id: '/summaries/',
    path: '/summaries/',
    getParentRoute: () => SystemAuthSurveysRouteRoute,
  } as any)
const SystemAuthSurveysQuestionsIndexRoute =
  SystemAuthSurveysQuestionsIndexRouteImport.update({
    id: '/questions/',
    path: '/questions/',
    getParentRoute: () => SystemAuthSurveysRouteRoute,
  } as any)
const SystemAuthSurveysCommentsIndexRoute =
  SystemAuthSurveysCommentsIndexRouteImport.update({
    id: '/comments/',
    path: '/comments/',
    getParentRoute: () => SystemAuthSurveysRouteRoute,
  } as any)
const SystemAuthSurveysCategoriesIndexRoute =
  SystemAuthSurveysCategoriesIndexRouteImport.update({
    id: '/categories/',
    path: '/categories/',
    getParentRoute: () => SystemAuthSurveysRouteRoute,
  } as any)
const SystemAuthOrganizationsOrganizationIdIndexRoute =
  SystemAuthOrganizationsOrganizationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SystemAuthOrganizationsOrganizationIdRouteRoute,
  } as any)
const ClientAuthSurveysSummariesIndexRoute =
  ClientAuthSurveysSummariesIndexRouteImport.update({
    id: '/summaries/',
    path: '/summaries/',
    getParentRoute: () => ClientAuthSurveysRouteRoute,
  } as any)
const ClientAuthSurveysQuestionsIndexRoute =
  ClientAuthSurveysQuestionsIndexRouteImport.update({
    id: '/questions/',
    path: '/questions/',
    getParentRoute: () => ClientAuthSurveysRouteRoute,
  } as any)
const ClientAuthSurveysCommentsIndexRoute =
  ClientAuthSurveysCommentsIndexRouteImport.update({
    id: '/comments/',
    path: '/comments/',
    getParentRoute: () => ClientAuthSurveysRouteRoute,
  } as any)
const ClientAuthSurveysCategoriesIndexRoute =
  ClientAuthSurveysCategoriesIndexRouteImport.update({
    id: '/categories/',
    path: '/categories/',
    getParentRoute: () => ClientAuthSurveysRouteRoute,
  } as any)
const SystemAuthReportingTasksNewIndexRoute =
  SystemAuthReportingTasksNewIndexRouteImport.update({
    id: '/reporting/tasks/new/',
    path: '/reporting/tasks/new/',
    getParentRoute: () => SystemAuthRouteRoute,
  } as any)
const SystemAuthReportingTasksTaskIdIndexRoute =
  SystemAuthReportingTasksTaskIdIndexRouteImport.update({
    id: '/reporting/tasks/$taskId/',
    path: '/reporting/tasks/$taskId/',
    getParentRoute: () => SystemAuthRouteRoute,
  } as any)
const SystemAuthOrganizationsOrganizationIdUsersIndexRoute =
  SystemAuthOrganizationsOrganizationIdUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => SystemAuthOrganizationsOrganizationIdRouteRoute,
  } as any)
const SystemAuthOrganizationsOrganizationIdSurveysIndexRoute =
  SystemAuthOrganizationsOrganizationIdSurveysIndexRouteImport.update({
    id: '/surveys/',
    path: '/surveys/',
    getParentRoute: () => SystemAuthOrganizationsOrganizationIdRouteRoute,
  } as any)
const SystemAuthOrganizationsOrganizationIdSurveySettingsIndexRoute =
  SystemAuthOrganizationsOrganizationIdSurveySettingsIndexRouteImport.update({
    id: '/survey-settings/',
    path: '/survey-settings/',
    getParentRoute: () => SystemAuthOrganizationsOrganizationIdRouteRoute,
  } as any)
const SystemAuthOrganizationsOrganizationIdReportsIndexRoute =
  SystemAuthOrganizationsOrganizationIdReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => SystemAuthOrganizationsOrganizationIdRouteRoute,
  } as any)
const SystemAuthOrganizationsOrganizationIdProfileIndexRoute =
  SystemAuthOrganizationsOrganizationIdProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => SystemAuthOrganizationsOrganizationIdRouteRoute,
  } as any)
const SystemAuthOrganizationsOrganizationIdOthersIndexRoute =
  SystemAuthOrganizationsOrganizationIdOthersIndexRouteImport.update({
    id: '/others/',
    path: '/others/',
    getParentRoute: () => SystemAuthOrganizationsOrganizationIdRouteRoute,
  } as any)
const SystemAuthOrganizationsOrganizationIdMappingIndexRoute =
  SystemAuthOrganizationsOrganizationIdMappingIndexRouteImport.update({
    id: '/mapping/',
    path: '/mapping/',
    getParentRoute: () => SystemAuthOrganizationsOrganizationIdRouteRoute,
  } as any)
const ClientAuthUsersUserIdSurveyPermissionsIndexRoute =
  ClientAuthUsersUserIdSurveyPermissionsIndexRouteImport.update({
    id: '/users/$userId/survey-permissions/',
    path: '/users/$userId/survey-permissions/',
    getParentRoute: () => ClientAuthRouteRoute,
  } as any)
const SystemAuthOrganizationsOrganizationIdUsersUserIdSurveyPermissionsIndexRoute =
  SystemAuthOrganizationsOrganizationIdUsersUserIdSurveyPermissionsIndexRouteImport.update(
    {
      id: '/users/$userId/survey-permissions/',
      path: '/users/$userId/survey-permissions/',
      getParentRoute: () => SystemAuthOrganizationsOrganizationIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof ClientAuthIndexRoute
  '/system': typeof SystemRouteRouteWithChildren
  '/surveys': typeof ClientAuthSurveysRouteRouteWithChildren
  '/system/surveys': typeof SystemAuthSurveysRouteRouteWithChildren
  '/$': typeof ClientAuthSplatRoute
  '/system/$': typeof SystemAuthSplatRoute
  '/system/': typeof SystemAuthIndexRoute
  '/system/organizations/$organizationId': typeof SystemAuthOrganizationsOrganizationIdRouteRouteWithChildren
  '/profile/': typeof ClientAuthProfileIndexRoute
  '/reports/': typeof ClientAuthReportsIndexRoute
  '/surveys/': typeof ClientAuthSurveysIndexRoute
  '/users/': typeof ClientAuthUsersIndexRoute
  '/system/organizations/': typeof SystemAuthOrganizationsIndexRoute
  '/system/profile/': typeof SystemAuthProfileIndexRoute
  '/system/reporting/': typeof SystemAuthReportingIndexRoute
  '/system/surveys/': typeof SystemAuthSurveysIndexRoute
  '/system/users/': typeof SystemAuthUsersIndexRoute
  '/surveys/categories/': typeof ClientAuthSurveysCategoriesIndexRoute
  '/surveys/comments/': typeof ClientAuthSurveysCommentsIndexRoute
  '/surveys/questions/': typeof ClientAuthSurveysQuestionsIndexRoute
  '/surveys/summaries/': typeof ClientAuthSurveysSummariesIndexRoute
  '/system/organizations/$organizationId/': typeof SystemAuthOrganizationsOrganizationIdIndexRoute
  '/system/surveys/categories/': typeof SystemAuthSurveysCategoriesIndexRoute
  '/system/surveys/comments/': typeof SystemAuthSurveysCommentsIndexRoute
  '/system/surveys/questions/': typeof SystemAuthSurveysQuestionsIndexRoute
  '/system/surveys/summaries/': typeof SystemAuthSurveysSummariesIndexRoute
  '/users/$userId/survey-permissions/': typeof ClientAuthUsersUserIdSurveyPermissionsIndexRoute
  '/system/organizations/$organizationId/mapping/': typeof SystemAuthOrganizationsOrganizationIdMappingIndexRoute
  '/system/organizations/$organizationId/others/': typeof SystemAuthOrganizationsOrganizationIdOthersIndexRoute
  '/system/organizations/$organizationId/profile/': typeof SystemAuthOrganizationsOrganizationIdProfileIndexRoute
  '/system/organizations/$organizationId/reports/': typeof SystemAuthOrganizationsOrganizationIdReportsIndexRoute
  '/system/organizations/$organizationId/survey-settings/': typeof SystemAuthOrganizationsOrganizationIdSurveySettingsIndexRoute
  '/system/organizations/$organizationId/surveys/': typeof SystemAuthOrganizationsOrganizationIdSurveysIndexRoute
  '/system/organizations/$organizationId/users/': typeof SystemAuthOrganizationsOrganizationIdUsersIndexRoute
  '/system/reporting/tasks/$taskId/': typeof SystemAuthReportingTasksTaskIdIndexRoute
  '/system/reporting/tasks/new/': typeof SystemAuthReportingTasksNewIndexRoute
  '/system/organizations/$organizationId/users/$userId/survey-permissions/': typeof SystemAuthOrganizationsOrganizationIdUsersUserIdSurveyPermissionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof ClientAuthIndexRoute
  '/system': typeof SystemAuthIndexRoute
  '/$': typeof ClientAuthSplatRoute
  '/system/$': typeof SystemAuthSplatRoute
  '/profile': typeof ClientAuthProfileIndexRoute
  '/reports': typeof ClientAuthReportsIndexRoute
  '/surveys': typeof ClientAuthSurveysIndexRoute
  '/users': typeof ClientAuthUsersIndexRoute
  '/system/organizations': typeof SystemAuthOrganizationsIndexRoute
  '/system/profile': typeof SystemAuthProfileIndexRoute
  '/system/reporting': typeof SystemAuthReportingIndexRoute
  '/system/surveys': typeof SystemAuthSurveysIndexRoute
  '/system/users': typeof SystemAuthUsersIndexRoute
  '/surveys/categories': typeof ClientAuthSurveysCategoriesIndexRoute
  '/surveys/comments': typeof ClientAuthSurveysCommentsIndexRoute
  '/surveys/questions': typeof ClientAuthSurveysQuestionsIndexRoute
  '/surveys/summaries': typeof ClientAuthSurveysSummariesIndexRoute
  '/system/organizations/$organizationId': typeof SystemAuthOrganizationsOrganizationIdIndexRoute
  '/system/surveys/categories': typeof SystemAuthSurveysCategoriesIndexRoute
  '/system/surveys/comments': typeof SystemAuthSurveysCommentsIndexRoute
  '/system/surveys/questions': typeof SystemAuthSurveysQuestionsIndexRoute
  '/system/surveys/summaries': typeof SystemAuthSurveysSummariesIndexRoute
  '/users/$userId/survey-permissions': typeof ClientAuthUsersUserIdSurveyPermissionsIndexRoute
  '/system/organizations/$organizationId/mapping': typeof SystemAuthOrganizationsOrganizationIdMappingIndexRoute
  '/system/organizations/$organizationId/others': typeof SystemAuthOrganizationsOrganizationIdOthersIndexRoute
  '/system/organizations/$organizationId/profile': typeof SystemAuthOrganizationsOrganizationIdProfileIndexRoute
  '/system/organizations/$organizationId/reports': typeof SystemAuthOrganizationsOrganizationIdReportsIndexRoute
  '/system/organizations/$organizationId/survey-settings': typeof SystemAuthOrganizationsOrganizationIdSurveySettingsIndexRoute
  '/system/organizations/$organizationId/surveys': typeof SystemAuthOrganizationsOrganizationIdSurveysIndexRoute
  '/system/organizations/$organizationId/users': typeof SystemAuthOrganizationsOrganizationIdUsersIndexRoute
  '/system/reporting/tasks/$taskId': typeof SystemAuthReportingTasksTaskIdIndexRoute
  '/system/reporting/tasks/new': typeof SystemAuthReportingTasksNewIndexRoute
  '/system/organizations/$organizationId/users/$userId/survey-permissions': typeof SystemAuthOrganizationsOrganizationIdUsersUserIdSurveyPermissionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_client': typeof ClientRouteRouteWithChildren
  '/system': typeof SystemRouteRouteWithChildren
  '/_client/_auth': typeof ClientAuthRouteRouteWithChildren
  '/system/_auth': typeof SystemAuthRouteRouteWithChildren
  '/_client/_auth/surveys': typeof ClientAuthSurveysRouteRouteWithChildren
  '/system/_auth/surveys': typeof SystemAuthSurveysRouteRouteWithChildren
  '/_client/_auth/$': typeof ClientAuthSplatRoute
  '/system/_auth/$': typeof SystemAuthSplatRoute
  '/_client/_auth/': typeof ClientAuthIndexRoute
  '/system/_auth/': typeof SystemAuthIndexRoute
  '/system/_auth/organizations/$organizationId': typeof SystemAuthOrganizationsOrganizationIdRouteRouteWithChildren
  '/_client/_auth/profile/': typeof ClientAuthProfileIndexRoute
  '/_client/_auth/reports/': typeof ClientAuthReportsIndexRoute
  '/_client/_auth/surveys/': typeof ClientAuthSurveysIndexRoute
  '/_client/_auth/users/': typeof ClientAuthUsersIndexRoute
  '/system/_auth/organizations/': typeof SystemAuthOrganizationsIndexRoute
  '/system/_auth/profile/': typeof SystemAuthProfileIndexRoute
  '/system/_auth/reporting/': typeof SystemAuthReportingIndexRoute
  '/system/_auth/surveys/': typeof SystemAuthSurveysIndexRoute
  '/system/_auth/users/': typeof SystemAuthUsersIndexRoute
  '/_client/_auth/surveys/categories/': typeof ClientAuthSurveysCategoriesIndexRoute
  '/_client/_auth/surveys/comments/': typeof ClientAuthSurveysCommentsIndexRoute
  '/_client/_auth/surveys/questions/': typeof ClientAuthSurveysQuestionsIndexRoute
  '/_client/_auth/surveys/summaries/': typeof ClientAuthSurveysSummariesIndexRoute
  '/system/_auth/organizations/$organizationId/': typeof SystemAuthOrganizationsOrganizationIdIndexRoute
  '/system/_auth/surveys/categories/': typeof SystemAuthSurveysCategoriesIndexRoute
  '/system/_auth/surveys/comments/': typeof SystemAuthSurveysCommentsIndexRoute
  '/system/_auth/surveys/questions/': typeof SystemAuthSurveysQuestionsIndexRoute
  '/system/_auth/surveys/summaries/': typeof SystemAuthSurveysSummariesIndexRoute
  '/_client/_auth/users/$userId/survey-permissions/': typeof ClientAuthUsersUserIdSurveyPermissionsIndexRoute
  '/system/_auth/organizations/$organizationId/mapping/': typeof SystemAuthOrganizationsOrganizationIdMappingIndexRoute
  '/system/_auth/organizations/$organizationId/others/': typeof SystemAuthOrganizationsOrganizationIdOthersIndexRoute
  '/system/_auth/organizations/$organizationId/profile/': typeof SystemAuthOrganizationsOrganizationIdProfileIndexRoute
  '/system/_auth/organizations/$organizationId/reports/': typeof SystemAuthOrganizationsOrganizationIdReportsIndexRoute
  '/system/_auth/organizations/$organizationId/survey-settings/': typeof SystemAuthOrganizationsOrganizationIdSurveySettingsIndexRoute
  '/system/_auth/organizations/$organizationId/surveys/': typeof SystemAuthOrganizationsOrganizationIdSurveysIndexRoute
  '/system/_auth/organizations/$organizationId/users/': typeof SystemAuthOrganizationsOrganizationIdUsersIndexRoute
  '/system/_auth/reporting/tasks/$taskId/': typeof SystemAuthReportingTasksTaskIdIndexRoute
  '/system/_auth/reporting/tasks/new/': typeof SystemAuthReportingTasksNewIndexRoute
  '/system/_auth/organizations/$organizationId/users/$userId/survey-permissions/': typeof SystemAuthOrganizationsOrganizationIdUsersUserIdSurveyPermissionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/system'
    | '/surveys'
    | '/system/surveys'
    | '/$'
    | '/system/$'
    | '/system/'
    | '/system/organizations/$organizationId'
    | '/profile/'
    | '/reports/'
    | '/surveys/'
    | '/users/'
    | '/system/organizations/'
    | '/system/profile/'
    | '/system/reporting/'
    | '/system/surveys/'
    | '/system/users/'
    | '/surveys/categories/'
    | '/surveys/comments/'
    | '/surveys/questions/'
    | '/surveys/summaries/'
    | '/system/organizations/$organizationId/'
    | '/system/surveys/categories/'
    | '/system/surveys/comments/'
    | '/system/surveys/questions/'
    | '/system/surveys/summaries/'
    | '/users/$userId/survey-permissions/'
    | '/system/organizations/$organizationId/mapping/'
    | '/system/organizations/$organizationId/others/'
    | '/system/organizations/$organizationId/profile/'
    | '/system/organizations/$organizationId/reports/'
    | '/system/organizations/$organizationId/survey-settings/'
    | '/system/organizations/$organizationId/surveys/'
    | '/system/organizations/$organizationId/users/'
    | '/system/reporting/tasks/$taskId/'
    | '/system/reporting/tasks/new/'
    | '/system/organizations/$organizationId/users/$userId/survey-permissions/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/system'
    | '/$'
    | '/system/$'
    | '/profile'
    | '/reports'
    | '/surveys'
    | '/users'
    | '/system/organizations'
    | '/system/profile'
    | '/system/reporting'
    | '/system/surveys'
    | '/system/users'
    | '/surveys/categories'
    | '/surveys/comments'
    | '/surveys/questions'
    | '/surveys/summaries'
    | '/system/organizations/$organizationId'
    | '/system/surveys/categories'
    | '/system/surveys/comments'
    | '/system/surveys/questions'
    | '/system/surveys/summaries'
    | '/users/$userId/survey-permissions'
    | '/system/organizations/$organizationId/mapping'
    | '/system/organizations/$organizationId/others'
    | '/system/organizations/$organizationId/profile'
    | '/system/organizations/$organizationId/reports'
    | '/system/organizations/$organizationId/survey-settings'
    | '/system/organizations/$organizationId/surveys'
    | '/system/organizations/$organizationId/users'
    | '/system/reporting/tasks/$taskId'
    | '/system/reporting/tasks/new'
    | '/system/organizations/$organizationId/users/$userId/survey-permissions'
  id:
    | '__root__'
    | '/_client'
    | '/system'
    | '/_client/_auth'
    | '/system/_auth'
    | '/_client/_auth/surveys'
    | '/system/_auth/surveys'
    | '/_client/_auth/$'
    | '/system/_auth/$'
    | '/_client/_auth/'
    | '/system/_auth/'
    | '/system/_auth/organizations/$organizationId'
    | '/_client/_auth/profile/'
    | '/_client/_auth/reports/'
    | '/_client/_auth/surveys/'
    | '/_client/_auth/users/'
    | '/system/_auth/organizations/'
    | '/system/_auth/profile/'
    | '/system/_auth/reporting/'
    | '/system/_auth/surveys/'
    | '/system/_auth/users/'
    | '/_client/_auth/surveys/categories/'
    | '/_client/_auth/surveys/comments/'
    | '/_client/_auth/surveys/questions/'
    | '/_client/_auth/surveys/summaries/'
    | '/system/_auth/organizations/$organizationId/'
    | '/system/_auth/surveys/categories/'
    | '/system/_auth/surveys/comments/'
    | '/system/_auth/surveys/questions/'
    | '/system/_auth/surveys/summaries/'
    | '/_client/_auth/users/$userId/survey-permissions/'
    | '/system/_auth/organizations/$organizationId/mapping/'
    | '/system/_auth/organizations/$organizationId/others/'
    | '/system/_auth/organizations/$organizationId/profile/'
    | '/system/_auth/organizations/$organizationId/reports/'
    | '/system/_auth/organizations/$organizationId/survey-settings/'
    | '/system/_auth/organizations/$organizationId/surveys/'
    | '/system/_auth/organizations/$organizationId/users/'
    | '/system/_auth/reporting/tasks/$taskId/'
    | '/system/_auth/reporting/tasks/new/'
    | '/system/_auth/organizations/$organizationId/users/$userId/survey-permissions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ClientRouteRoute: typeof ClientRouteRouteWithChildren
  SystemRouteRoute: typeof SystemRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/system': {
      id: '/system'
      path: '/system'
      fullPath: '/system'
      preLoaderRoute: typeof SystemRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_client': {
      id: '/_client'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ClientRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/_auth': {
      id: '/system/_auth'
      path: ''
      fullPath: '/system'
      preLoaderRoute: typeof SystemAuthRouteRouteImport
      parentRoute: typeof SystemRouteRoute
    }
    '/_client/_auth': {
      id: '/_client/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ClientAuthRouteRouteImport
      parentRoute: typeof ClientRouteRoute
    }
    '/system/_auth/': {
      id: '/system/_auth/'
      path: '/'
      fullPath: '/system/'
      preLoaderRoute: typeof SystemAuthIndexRouteImport
      parentRoute: typeof SystemAuthRouteRoute
    }
    '/_client/_auth/': {
      id: '/_client/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ClientAuthIndexRouteImport
      parentRoute: typeof ClientAuthRouteRoute
    }
    '/system/_auth/$': {
      id: '/system/_auth/$'
      path: '/$'
      fullPath: '/system/$'
      preLoaderRoute: typeof SystemAuthSplatRouteImport
      parentRoute: typeof SystemAuthRouteRoute
    }
    '/_client/_auth/$': {
      id: '/_client/_auth/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof ClientAuthSplatRouteImport
      parentRoute: typeof ClientAuthRouteRoute
    }
    '/system/_auth/surveys': {
      id: '/system/_auth/surveys'
      path: '/surveys'
      fullPath: '/system/surveys'
      preLoaderRoute: typeof SystemAuthSurveysRouteRouteImport
      parentRoute: typeof SystemAuthRouteRoute
    }
    '/_client/_auth/surveys': {
      id: '/_client/_auth/surveys'
      path: '/surveys'
      fullPath: '/surveys'
      preLoaderRoute: typeof ClientAuthSurveysRouteRouteImport
      parentRoute: typeof ClientAuthRouteRoute
    }
    '/system/_auth/users/': {
      id: '/system/_auth/users/'
      path: '/users'
      fullPath: '/system/users/'
      preLoaderRoute: typeof SystemAuthUsersIndexRouteImport
      parentRoute: typeof SystemAuthRouteRoute
    }
    '/system/_auth/surveys/': {
      id: '/system/_auth/surveys/'
      path: '/'
      fullPath: '/system/surveys/'
      preLoaderRoute: typeof SystemAuthSurveysIndexRouteImport
      parentRoute: typeof SystemAuthSurveysRouteRoute
    }
    '/system/_auth/reporting/': {
      id: '/system/_auth/reporting/'
      path: '/reporting'
      fullPath: '/system/reporting/'
      preLoaderRoute: typeof SystemAuthReportingIndexRouteImport
      parentRoute: typeof SystemAuthRouteRoute
    }
    '/system/_auth/profile/': {
      id: '/system/_auth/profile/'
      path: '/profile'
      fullPath: '/system/profile/'
      preLoaderRoute: typeof SystemAuthProfileIndexRouteImport
      parentRoute: typeof SystemAuthRouteRoute
    }
    '/system/_auth/organizations/': {
      id: '/system/_auth/organizations/'
      path: '/organizations'
      fullPath: '/system/organizations/'
      preLoaderRoute: typeof SystemAuthOrganizationsIndexRouteImport
      parentRoute: typeof SystemAuthRouteRoute
    }
    '/_client/_auth/users/': {
      id: '/_client/_auth/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof ClientAuthUsersIndexRouteImport
      parentRoute: typeof ClientAuthRouteRoute
    }
    '/_client/_auth/surveys/': {
      id: '/_client/_auth/surveys/'
      path: '/'
      fullPath: '/surveys/'
      preLoaderRoute: typeof ClientAuthSurveysIndexRouteImport
      parentRoute: typeof ClientAuthSurveysRouteRoute
    }
    '/_client/_auth/reports/': {
      id: '/_client/_auth/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof ClientAuthReportsIndexRouteImport
      parentRoute: typeof ClientAuthRouteRoute
    }
    '/_client/_auth/profile/': {
      id: '/_client/_auth/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof ClientAuthProfileIndexRouteImport
      parentRoute: typeof ClientAuthRouteRoute
    }
    '/system/_auth/organizations/$organizationId': {
      id: '/system/_auth/organizations/$organizationId'
      path: '/organizations/$organizationId'
      fullPath: '/system/organizations/$organizationId'
      preLoaderRoute: typeof SystemAuthOrganizationsOrganizationIdRouteRouteImport
      parentRoute: typeof SystemAuthRouteRoute
    }
    '/system/_auth/surveys/summaries/': {
      id: '/system/_auth/surveys/summaries/'
      path: '/summaries'
      fullPath: '/system/surveys/summaries/'
      preLoaderRoute: typeof SystemAuthSurveysSummariesIndexRouteImport
      parentRoute: typeof SystemAuthSurveysRouteRoute
    }
    '/system/_auth/surveys/questions/': {
      id: '/system/_auth/surveys/questions/'
      path: '/questions'
      fullPath: '/system/surveys/questions/'
      preLoaderRoute: typeof SystemAuthSurveysQuestionsIndexRouteImport
      parentRoute: typeof SystemAuthSurveysRouteRoute
    }
    '/system/_auth/surveys/comments/': {
      id: '/system/_auth/surveys/comments/'
      path: '/comments'
      fullPath: '/system/surveys/comments/'
      preLoaderRoute: typeof SystemAuthSurveysCommentsIndexRouteImport
      parentRoute: typeof SystemAuthSurveysRouteRoute
    }
    '/system/_auth/surveys/categories/': {
      id: '/system/_auth/surveys/categories/'
      path: '/categories'
      fullPath: '/system/surveys/categories/'
      preLoaderRoute: typeof SystemAuthSurveysCategoriesIndexRouteImport
      parentRoute: typeof SystemAuthSurveysRouteRoute
    }
    '/system/_auth/organizations/$organizationId/': {
      id: '/system/_auth/organizations/$organizationId/'
      path: '/'
      fullPath: '/system/organizations/$organizationId/'
      preLoaderRoute: typeof SystemAuthOrganizationsOrganizationIdIndexRouteImport
      parentRoute: typeof SystemAuthOrganizationsOrganizationIdRouteRoute
    }
    '/_client/_auth/surveys/summaries/': {
      id: '/_client/_auth/surveys/summaries/'
      path: '/summaries'
      fullPath: '/surveys/summaries/'
      preLoaderRoute: typeof ClientAuthSurveysSummariesIndexRouteImport
      parentRoute: typeof ClientAuthSurveysRouteRoute
    }
    '/_client/_auth/surveys/questions/': {
      id: '/_client/_auth/surveys/questions/'
      path: '/questions'
      fullPath: '/surveys/questions/'
      preLoaderRoute: typeof ClientAuthSurveysQuestionsIndexRouteImport
      parentRoute: typeof ClientAuthSurveysRouteRoute
    }
    '/_client/_auth/surveys/comments/': {
      id: '/_client/_auth/surveys/comments/'
      path: '/comments'
      fullPath: '/surveys/comments/'
      preLoaderRoute: typeof ClientAuthSurveysCommentsIndexRouteImport
      parentRoute: typeof ClientAuthSurveysRouteRoute
    }
    '/_client/_auth/surveys/categories/': {
      id: '/_client/_auth/surveys/categories/'
      path: '/categories'
      fullPath: '/surveys/categories/'
      preLoaderRoute: typeof ClientAuthSurveysCategoriesIndexRouteImport
      parentRoute: typeof ClientAuthSurveysRouteRoute
    }
    '/system/_auth/reporting/tasks/new/': {
      id: '/system/_auth/reporting/tasks/new/'
      path: '/reporting/tasks/new'
      fullPath: '/system/reporting/tasks/new/'
      preLoaderRoute: typeof SystemAuthReportingTasksNewIndexRouteImport
      parentRoute: typeof SystemAuthRouteRoute
    }
    '/system/_auth/reporting/tasks/$taskId/': {
      id: '/system/_auth/reporting/tasks/$taskId/'
      path: '/reporting/tasks/$taskId'
      fullPath: '/system/reporting/tasks/$taskId/'
      preLoaderRoute: typeof SystemAuthReportingTasksTaskIdIndexRouteImport
      parentRoute: typeof SystemAuthRouteRoute
    }
    '/system/_auth/organizations/$organizationId/users/': {
      id: '/system/_auth/organizations/$organizationId/users/'
      path: '/users'
      fullPath: '/system/organizations/$organizationId/users/'
      preLoaderRoute: typeof SystemAuthOrganizationsOrganizationIdUsersIndexRouteImport
      parentRoute: typeof SystemAuthOrganizationsOrganizationIdRouteRoute
    }
    '/system/_auth/organizations/$organizationId/surveys/': {
      id: '/system/_auth/organizations/$organizationId/surveys/'
      path: '/surveys'
      fullPath: '/system/organizations/$organizationId/surveys/'
      preLoaderRoute: typeof SystemAuthOrganizationsOrganizationIdSurveysIndexRouteImport
      parentRoute: typeof SystemAuthOrganizationsOrganizationIdRouteRoute
    }
    '/system/_auth/organizations/$organizationId/survey-settings/': {
      id: '/system/_auth/organizations/$organizationId/survey-settings/'
      path: '/survey-settings'
      fullPath: '/system/organizations/$organizationId/survey-settings/'
      preLoaderRoute: typeof SystemAuthOrganizationsOrganizationIdSurveySettingsIndexRouteImport
      parentRoute: typeof SystemAuthOrganizationsOrganizationIdRouteRoute
    }
    '/system/_auth/organizations/$organizationId/reports/': {
      id: '/system/_auth/organizations/$organizationId/reports/'
      path: '/reports'
      fullPath: '/system/organizations/$organizationId/reports/'
      preLoaderRoute: typeof SystemAuthOrganizationsOrganizationIdReportsIndexRouteImport
      parentRoute: typeof SystemAuthOrganizationsOrganizationIdRouteRoute
    }
    '/system/_auth/organizations/$organizationId/profile/': {
      id: '/system/_auth/organizations/$organizationId/profile/'
      path: '/profile'
      fullPath: '/system/organizations/$organizationId/profile/'
      preLoaderRoute: typeof SystemAuthOrganizationsOrganizationIdProfileIndexRouteImport
      parentRoute: typeof SystemAuthOrganizationsOrganizationIdRouteRoute
    }
    '/system/_auth/organizations/$organizationId/others/': {
      id: '/system/_auth/organizations/$organizationId/others/'
      path: '/others'
      fullPath: '/system/organizations/$organizationId/others/'
      preLoaderRoute: typeof SystemAuthOrganizationsOrganizationIdOthersIndexRouteImport
      parentRoute: typeof SystemAuthOrganizationsOrganizationIdRouteRoute
    }
    '/system/_auth/organizations/$organizationId/mapping/': {
      id: '/system/_auth/organizations/$organizationId/mapping/'
      path: '/mapping'
      fullPath: '/system/organizations/$organizationId/mapping/'
      preLoaderRoute: typeof SystemAuthOrganizationsOrganizationIdMappingIndexRouteImport
      parentRoute: typeof SystemAuthOrganizationsOrganizationIdRouteRoute
    }
    '/_client/_auth/users/$userId/survey-permissions/': {
      id: '/_client/_auth/users/$userId/survey-permissions/'
      path: '/users/$userId/survey-permissions'
      fullPath: '/users/$userId/survey-permissions/'
      preLoaderRoute: typeof ClientAuthUsersUserIdSurveyPermissionsIndexRouteImport
      parentRoute: typeof ClientAuthRouteRoute
    }
    '/system/_auth/organizations/$organizationId/users/$userId/survey-permissions/': {
      id: '/system/_auth/organizations/$organizationId/users/$userId/survey-permissions/'
      path: '/users/$userId/survey-permissions'
      fullPath: '/system/organizations/$organizationId/users/$userId/survey-permissions/'
      preLoaderRoute: typeof SystemAuthOrganizationsOrganizationIdUsersUserIdSurveyPermissionsIndexRouteImport
      parentRoute: typeof SystemAuthOrganizationsOrganizationIdRouteRoute
    }
  }
}

interface ClientAuthSurveysRouteRouteChildren {
  ClientAuthSurveysIndexRoute: typeof ClientAuthSurveysIndexRoute
  ClientAuthSurveysCategoriesIndexRoute: typeof ClientAuthSurveysCategoriesIndexRoute
  ClientAuthSurveysCommentsIndexRoute: typeof ClientAuthSurveysCommentsIndexRoute
  ClientAuthSurveysQuestionsIndexRoute: typeof ClientAuthSurveysQuestionsIndexRoute
  ClientAuthSurveysSummariesIndexRoute: typeof ClientAuthSurveysSummariesIndexRoute
}

const ClientAuthSurveysRouteRouteChildren: ClientAuthSurveysRouteRouteChildren =
  {
    ClientAuthSurveysIndexRoute: ClientAuthSurveysIndexRoute,
    ClientAuthSurveysCategoriesIndexRoute:
      ClientAuthSurveysCategoriesIndexRoute,
    ClientAuthSurveysCommentsIndexRoute: ClientAuthSurveysCommentsIndexRoute,
    ClientAuthSurveysQuestionsIndexRoute: ClientAuthSurveysQuestionsIndexRoute,
    ClientAuthSurveysSummariesIndexRoute: ClientAuthSurveysSummariesIndexRoute,
  }

const ClientAuthSurveysRouteRouteWithChildren =
  ClientAuthSurveysRouteRoute._addFileChildren(
    ClientAuthSurveysRouteRouteChildren,
  )

interface ClientAuthRouteRouteChildren {
  ClientAuthSurveysRouteRoute: typeof ClientAuthSurveysRouteRouteWithChildren
  ClientAuthSplatRoute: typeof ClientAuthSplatRoute
  ClientAuthIndexRoute: typeof ClientAuthIndexRoute
  ClientAuthProfileIndexRoute: typeof ClientAuthProfileIndexRoute
  ClientAuthReportsIndexRoute: typeof ClientAuthReportsIndexRoute
  ClientAuthUsersIndexRoute: typeof ClientAuthUsersIndexRoute
  ClientAuthUsersUserIdSurveyPermissionsIndexRoute: typeof ClientAuthUsersUserIdSurveyPermissionsIndexRoute
}

const ClientAuthRouteRouteChildren: ClientAuthRouteRouteChildren = {
  ClientAuthSurveysRouteRoute: ClientAuthSurveysRouteRouteWithChildren,
  ClientAuthSplatRoute: ClientAuthSplatRoute,
  ClientAuthIndexRoute: ClientAuthIndexRoute,
  ClientAuthProfileIndexRoute: ClientAuthProfileIndexRoute,
  ClientAuthReportsIndexRoute: ClientAuthReportsIndexRoute,
  ClientAuthUsersIndexRoute: ClientAuthUsersIndexRoute,
  ClientAuthUsersUserIdSurveyPermissionsIndexRoute:
    ClientAuthUsersUserIdSurveyPermissionsIndexRoute,
}

const ClientAuthRouteRouteWithChildren = ClientAuthRouteRoute._addFileChildren(
  ClientAuthRouteRouteChildren,
)

interface ClientRouteRouteChildren {
  ClientAuthRouteRoute: typeof ClientAuthRouteRouteWithChildren
}

const ClientRouteRouteChildren: ClientRouteRouteChildren = {
  ClientAuthRouteRoute: ClientAuthRouteRouteWithChildren,
}

const ClientRouteRouteWithChildren = ClientRouteRoute._addFileChildren(
  ClientRouteRouteChildren,
)

interface SystemAuthSurveysRouteRouteChildren {
  SystemAuthSurveysIndexRoute: typeof SystemAuthSurveysIndexRoute
  SystemAuthSurveysCategoriesIndexRoute: typeof SystemAuthSurveysCategoriesIndexRoute
  SystemAuthSurveysCommentsIndexRoute: typeof SystemAuthSurveysCommentsIndexRoute
  SystemAuthSurveysQuestionsIndexRoute: typeof SystemAuthSurveysQuestionsIndexRoute
  SystemAuthSurveysSummariesIndexRoute: typeof SystemAuthSurveysSummariesIndexRoute
}

const SystemAuthSurveysRouteRouteChildren: SystemAuthSurveysRouteRouteChildren =
  {
    SystemAuthSurveysIndexRoute: SystemAuthSurveysIndexRoute,
    SystemAuthSurveysCategoriesIndexRoute:
      SystemAuthSurveysCategoriesIndexRoute,
    SystemAuthSurveysCommentsIndexRoute: SystemAuthSurveysCommentsIndexRoute,
    SystemAuthSurveysQuestionsIndexRoute: SystemAuthSurveysQuestionsIndexRoute,
    SystemAuthSurveysSummariesIndexRoute: SystemAuthSurveysSummariesIndexRoute,
  }

const SystemAuthSurveysRouteRouteWithChildren =
  SystemAuthSurveysRouteRoute._addFileChildren(
    SystemAuthSurveysRouteRouteChildren,
  )

interface SystemAuthOrganizationsOrganizationIdRouteRouteChildren {
  SystemAuthOrganizationsOrganizationIdIndexRoute: typeof SystemAuthOrganizationsOrganizationIdIndexRoute
  SystemAuthOrganizationsOrganizationIdMappingIndexRoute: typeof SystemAuthOrganizationsOrganizationIdMappingIndexRoute
  SystemAuthOrganizationsOrganizationIdOthersIndexRoute: typeof SystemAuthOrganizationsOrganizationIdOthersIndexRoute
  SystemAuthOrganizationsOrganizationIdProfileIndexRoute: typeof SystemAuthOrganizationsOrganizationIdProfileIndexRoute
  SystemAuthOrganizationsOrganizationIdReportsIndexRoute: typeof SystemAuthOrganizationsOrganizationIdReportsIndexRoute
  SystemAuthOrganizationsOrganizationIdSurveySettingsIndexRoute: typeof SystemAuthOrganizationsOrganizationIdSurveySettingsIndexRoute
  SystemAuthOrganizationsOrganizationIdSurveysIndexRoute: typeof SystemAuthOrganizationsOrganizationIdSurveysIndexRoute
  SystemAuthOrganizationsOrganizationIdUsersIndexRoute: typeof SystemAuthOrganizationsOrganizationIdUsersIndexRoute
  SystemAuthOrganizationsOrganizationIdUsersUserIdSurveyPermissionsIndexRoute: typeof SystemAuthOrganizationsOrganizationIdUsersUserIdSurveyPermissionsIndexRoute
}

const SystemAuthOrganizationsOrganizationIdRouteRouteChildren: SystemAuthOrganizationsOrganizationIdRouteRouteChildren =
  {
    SystemAuthOrganizationsOrganizationIdIndexRoute:
      SystemAuthOrganizationsOrganizationIdIndexRoute,
    SystemAuthOrganizationsOrganizationIdMappingIndexRoute:
      SystemAuthOrganizationsOrganizationIdMappingIndexRoute,
    SystemAuthOrganizationsOrganizationIdOthersIndexRoute:
      SystemAuthOrganizationsOrganizationIdOthersIndexRoute,
    SystemAuthOrganizationsOrganizationIdProfileIndexRoute:
      SystemAuthOrganizationsOrganizationIdProfileIndexRoute,
    SystemAuthOrganizationsOrganizationIdReportsIndexRoute:
      SystemAuthOrganizationsOrganizationIdReportsIndexRoute,
    SystemAuthOrganizationsOrganizationIdSurveySettingsIndexRoute:
      SystemAuthOrganizationsOrganizationIdSurveySettingsIndexRoute,
    SystemAuthOrganizationsOrganizationIdSurveysIndexRoute:
      SystemAuthOrganizationsOrganizationIdSurveysIndexRoute,
    SystemAuthOrganizationsOrganizationIdUsersIndexRoute:
      SystemAuthOrganizationsOrganizationIdUsersIndexRoute,
    SystemAuthOrganizationsOrganizationIdUsersUserIdSurveyPermissionsIndexRoute:
      SystemAuthOrganizationsOrganizationIdUsersUserIdSurveyPermissionsIndexRoute,
  }

const SystemAuthOrganizationsOrganizationIdRouteRouteWithChildren =
  SystemAuthOrganizationsOrganizationIdRouteRoute._addFileChildren(
    SystemAuthOrganizationsOrganizationIdRouteRouteChildren,
  )

interface SystemAuthRouteRouteChildren {
  SystemAuthSurveysRouteRoute: typeof SystemAuthSurveysRouteRouteWithChildren
  SystemAuthSplatRoute: typeof SystemAuthSplatRoute
  SystemAuthIndexRoute: typeof SystemAuthIndexRoute
  SystemAuthOrganizationsOrganizationIdRouteRoute: typeof SystemAuthOrganizationsOrganizationIdRouteRouteWithChildren
  SystemAuthOrganizationsIndexRoute: typeof SystemAuthOrganizationsIndexRoute
  SystemAuthProfileIndexRoute: typeof SystemAuthProfileIndexRoute
  SystemAuthReportingIndexRoute: typeof SystemAuthReportingIndexRoute
  SystemAuthUsersIndexRoute: typeof SystemAuthUsersIndexRoute
  SystemAuthReportingTasksTaskIdIndexRoute: typeof SystemAuthReportingTasksTaskIdIndexRoute
  SystemAuthReportingTasksNewIndexRoute: typeof SystemAuthReportingTasksNewIndexRoute
}

const SystemAuthRouteRouteChildren: SystemAuthRouteRouteChildren = {
  SystemAuthSurveysRouteRoute: SystemAuthSurveysRouteRouteWithChildren,
  SystemAuthSplatRoute: SystemAuthSplatRoute,
  SystemAuthIndexRoute: SystemAuthIndexRoute,
  SystemAuthOrganizationsOrganizationIdRouteRoute:
    SystemAuthOrganizationsOrganizationIdRouteRouteWithChildren,
  SystemAuthOrganizationsIndexRoute: SystemAuthOrganizationsIndexRoute,
  SystemAuthProfileIndexRoute: SystemAuthProfileIndexRoute,
  SystemAuthReportingIndexRoute: SystemAuthReportingIndexRoute,
  SystemAuthUsersIndexRoute: SystemAuthUsersIndexRoute,
  SystemAuthReportingTasksTaskIdIndexRoute:
    SystemAuthReportingTasksTaskIdIndexRoute,
  SystemAuthReportingTasksNewIndexRoute: SystemAuthReportingTasksNewIndexRoute,
}

const SystemAuthRouteRouteWithChildren = SystemAuthRouteRoute._addFileChildren(
  SystemAuthRouteRouteChildren,
)

interface SystemRouteRouteChildren {
  SystemAuthRouteRoute: typeof SystemAuthRouteRouteWithChildren
}

const SystemRouteRouteChildren: SystemRouteRouteChildren = {
  SystemAuthRouteRoute: SystemAuthRouteRouteWithChildren,
}

const SystemRouteRouteWithChildren = SystemRouteRoute._addFileChildren(
  SystemRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  ClientRouteRoute: ClientRouteRouteWithChildren,
  SystemRouteRoute: SystemRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
